import styled from "styled-components";

export const TitleStyled = styled.h3`
font-size:inherit;
color: inherit;
`;
